'use client'

import { Scissors } from "lucide-react";

type Props = { onBook: () => void };

export function SiteHeader({ onBook }: Props) {
  return (
    <header className="fixed left-0 right-0 top-0 z-30 border-b border-border/50 bg-background/70 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-5 md:px-12">
        <a href="#" className="flex items-center gap-2">
          <Scissors className="h-4 w-4 text-rose-gold" />
          <span className="font-display text-xl tracking-wide">MAISON NOIR</span>
        </a>
        <nav className="hidden items-center gap-10 text-[0.7rem] uppercase tracking-editorial md:flex">
          <a href="#stylists" className="hover:text-rose-gold">Professionals</a>
          <a href="#gallery" className="hover:text-rose-gold">Gallery</a>
          <a href="#journal" className="hover:text-rose-gold">Journal</a>
          <a href="#visit" className="hover:text-rose-gold">Visit</a>
        </nav>
        <button onClick={onBook} className="btn-editorial !px-5 !py-3 text-[0.6rem]">
          Book
        </button>
      </div>
    </header>
  );
}
